import React, {Component} from "react";
import {Input, Label} from "reactstrap";
import get from 'lodash/get'
import isEqual from "lodash/isEqual";
import SelectField from "./SelectField";
import i18next from 'i18next';


export default class PriceField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            amount: this.props.formData?.amount,
            currency: this.props.formData?.currency,
        };

        this.onChange = this.onChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.onChangeCurrency = this.onChangeCurrency.bind(this);

    }

    componentDidMount() {
        if (this.state.amount) {
            const newFormData = parseFloat(this.state.amount.toString()).toString();
            this.setState({amount: newFormData});
        }

    }

    onChange(event) {
        let newFormData = event.target.value;
        newFormData = newFormData?.toString().replaceAll(',', '.');
        if (!!isNaN(newFormData)) {
            newFormData = this.state.amount;
        }
        if (newFormData && newFormData.indexOf('.') !== -1) {
            let smth = newFormData.split('.');
            if (smth[1] && smth[1].length > 2) {
                newFormData = smth[0] + '.' + smth[1].toString().substring(0, 2)
            }
        }

        newFormData = {...this.state, ...{amount: newFormData}}
        this.setState(newFormData);
        this.props.onChange(newFormData);
    }

    handleKeyDown(event) {

    }

    onChangeCurrency(event) {
        const newFormData = {...this.state, ...{currency: event.id}}
        this.setState(newFormData);
        this.props.onChange(newFormData);
    }

    render() {
        return <>
            <Label className='mt-3'>
                {i18next.t(this.props.schema.title)}
                {(this.props.schema.title && this.props.required) ? ' *' : ''}
            </Label>
            <Input
                disabled={this.props.uiSchema?.['ui:readonly']}
                value={this.state.amount}
                readOnly={get(this.props, ['uiSchema', 'ui:readonly'])}
                onChange={this.onChange}
            />
            <SelectField
                schema={this.props.schema.currency_scheme}
                formData={this.state.currency}
                onChange={this.onChangeCurrency}
                required={true}
                uiSchema={this.props.uiSchema}
            />
        </>;
    }
}
